<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> 风险评估 </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <span class="page-title">项目基本信息</span>
      <div class="action-container">
        <a-button type="primary" class="action-btn" @click="onPass">
          评估通过，进入下一部分
        </a-button>
        <a-button type="danger" class="action-btn" @click="onReject">
          评估不通过
        </a-button>
        <a-input placeholder="请输入复核意见" v-model="auditOpinion" class="short-text-input"/>
      </div>
    </div>
    <div class="content-container">
      <div class="container">
        <SectionTwo v-bind="sectionTwoData" />

      </div>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {loadSectionOne, loadSectionTwo} from "@/services/SpecService";
import {auditProject, auditSectionTwo} from "@/services/DocService";
import {saveRiskAssess} from "@/services/RiskService";
import SectionTwo from "@/views/SectionTwo.vue";

export default {
  components: {SectionTwo, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      projectId: "",
      current: 1,
      metricsGroupList: [
        {
          groupId: "group1",
          groupName: "项目底层企业信息"
        },
        {
          groupId: "group2",
          groupName: "项目基本信息"
        },
        {
          groupId: "group3",
          groupName: "前期手续"
        },
      ],
      headers: {
        authorization: 'authorization-text',
      },
      viewUrl: baseURL + "/attachment?fileName=",
      sectionTwoData: {
        sectionTwo: {
          landUser: "",
          rightsClear: "",
          rightsClearRemark: "",
          operatorType: "",
          explosiveRisk: "",
          produceCorrosive: "",
          produceCorrosiveRemark: "",
          leakingRisk: "",
          collapseRisk: "",
          flatRoof: "",
          slopeRoof: "",
          breakage: "",
          blockage: "",
          blockageRemark: "",
          solarConsidered: "",
          bizHealth: "",
          bizHealthRemark: "",
          dishonest: "",
          dishonestRemark: "",
          businessRisk: "",
          businessRiskRemark: "",
          slopeDegree: "",
          rationaleState: "",
          usageAgreement: "",
          leaseStartYear: "",
          leasePrice: "",
          settlePrice: "",
          envReview: "",
          envReviewRemark: "",
          socialReview: "",
          socialReviewRemark: "",
          otherReview:"",
          otherReviewRemark: ""
        },
        landCert: {
          loading: false,
          docList: [],
          title: "土地证"
        },
        ownerCert: {
          loading: false,
          docList: [],
          title: "产权证"
        },
        leaseAgreement: {
          loading: false,
          docList: [],
          title: "租赁协议"
        },
        energyContract: {
          loading: false,
          docList: [],
          title: "能源租赁合同"
        },
        existenceCert: {
          loading: false,
          docList: [],
          title: "持续性经营证明文件"
        },
        solarBlueprint: {
          loading: false,
          docList: [],
          title: "设计图纸（组件排布图）"
        },
        registration:{
          loading: false,
          docList: [],
          title: ""
        },
        honestScreenshot: {
          loading: false,
          imageUrl: "",
          title: "查询截图"
        },
      },
      auditOpinion: ""
    };
  },
  created() {
    this.projectId = this.$route.params.id;
    console.log('projectId', this.projectId);
    if(this.projectId==='0') {
      this.projectId = "";
    } else {
      this.pageTitle = "编辑表单";
    }
  },
  mounted() {
    this.startLoadSectionTwo();
  },
  methods: {
    startLoadSectionTwo(){
      if(this.projectId!=="") {
        loadSectionTwo(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            if(data.dishonestImageUrl) {
              this.sectionTwoData.honestScreenshot.imageUrl = this.viewUrl + data.dishonestImageUrl;
            }
            this.sectionTwoData.sectionTwo = data;

            this.buildDocList('sectionTwoData',data.landCertDocList, 'landCert');
            this.buildDocList('sectionTwoData',data.ownerCertDocList, 'ownerCert');
            this.buildDocList('sectionTwoData',data.leaseAgreementDocList, 'leaseAgreement');
            this.buildDocList('sectionTwoData',data.existenceCertDocList, 'existenceCert');
            this.buildDocList('sectionTwoData',data.solarBlueprintDocList, 'solarBlueprint');
            this.buildDocList('sectionTwoData',data.registrationDocList, 'registration');
            this.buildDocList('sectionTwoData',data.energyContractDocList, 'energyContract');
          }
        });
      }
    },
    buildDocList(sectionName,docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[sectionName][propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    onPass() {
      let params = {
        projectId: this.projectId,
        pass: true,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    onReject() {
      let params = {
        projectId: this.projectId,
        pass: false,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    audit(params) {
      if(this.current===0){
        params.section = "sectionOne";
      }
      if(this.current===1){
        params.section = "sectionTwo";
      }
      if(this.current===2){
        params.section = "sectionThree";
      }
      saveRiskAssess(params).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          if(params.pass) {
            this.$router.replace({ name: "RiskReviewThree", params: { id: this.projectId } });
          } else {
            this.$router.push({ name: "RiskReviewList" });
          }
        } else {
          this.$message.error("操作失败:" + resp.data.errorMsg);
        }
      });
    }

  }
}
</script>
<style scoped>

</style>
